import React from "react";
import Hero from "@/components/landing/Hero";
import TrustedBy from "@/components/landing/TrustedBy";
import Problem from "@/components/landing/Problem";
import SolutionBento from "@/components/landing/SolutionBento";
import ProductScreens from "@/components/landing/ProductScreens";
import Multilingual from "@/components/landing/Multilingual";
import HowItWorks from "@/components/landing/HowItWorks";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import PageMeta from "@/components/PageMeta";

export default function Home() {
  return (
    <>
      <PageMeta title="One Operating Record for Retail" description="Know what happened in your shop today and what to do next with connected sales, stock, customer balances, expenses, staff activity, and insights." />
      <Hero />
      <TrustedBy />
      <Problem />
      <SolutionBento />
      <ProductScreens />
      <Multilingual />
      <HowItWorks />
      <Pricing />
      <Testimonials />
      <FAQ />
      <FinalCTA />
    </>
  );
}
